import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { Tablev2Component } from '../tablev2/tablev2.component';

@Component({
  selector: 'app-draw-sections',
  templateUrl: './draw-sections.component.html',
  styleUrls: ['./draw-sections.component.scss']
})
export class DrawSectionsComponent implements AfterViewInit {

  public company_uuid;
  public promotionRules: any = {
    enabled: false,
    promotion_uuid: null,
    turnover: 200,
    minimum_payout: 100,
    maximum_payout: 100,
  };
  public savingRules = false;
  public promotions: any[] = [];
  @ViewChild("table", { static: false }) tb: Tablev2Component;

  constructor(private http: HttpService, private cdr : ChangeDetectorRef) {
    this.http.getSelectedCompany().subscribe(val => {
      this.company_uuid = val;
    });
   }

  ngAfterViewInit(): void {
      this.init();
  }

  async init() {
    const rules: any = await this.http.post('/admin/lucky-draw-promotion/get');
    if (rules) {
      this.promotions = rules.promotions || [];
      const { promotions, ...promotionRules } = rules;
      this.promotionRules = promotionRules;
    }
    const setting = 
        { post: {url: "/admin/app/lucky-draw-section", data: {page_nat: false, uuid: this.company_uuid}},
          disabled_pagenat: true,
          fields: [
            {label: 'No', type: 'index'}, 
            {label: 'Color', type: 'string', key: 'color'}, 
            {label: 'Label', type: 'string', key: 'label'}, 
            {label: 'Value', type: 'string', key: 'value'}, 
            {label: 'Status', type: 'status', key: 'status'}, 
            {label: 'Sorting', type: 'string', key: 'sort'},
            {label: 'View', type: 'link', key: 'uuid', 'link': '/lo' + (this.company_uuid ? '/' + this.company_uuid : '/null') + "/draw-section/form", hide: true},
            {label: 'Delete', type: 'delete', key: 'uuid', table: 'draw_section', title: 'label', hide: true},
          ]}
      this.tb.init(setting);
  }

  promotionChanged() {
    const promotion = this.promotions.find(item => item.uuid === this.promotionRules.promotion_uuid);
    if (!promotion) return;

    this.promotionRules.turnover = this.validRuleAmount(promotion.min_trigger, 200);
    this.promotionRules.minimum_payout = this.validRuleAmount(promotion.min_withdraw, 100);
    this.promotionRules.maximum_payout = this.validRuleAmount(promotion.max_withdraw, 100);
  }

  private validRuleAmount(value, fallback) {
    const amount = Number(value);
    return Number.isFinite(amount) && amount >= 0 ? amount : fallback;
  }

  async savePromotionRules(form) {
    if (form.invalid || this.savingRules) return;
    this.savingRules = true;
    try {
      const result: any = await this.http.post('/admin/lucky-draw-promotion/update', this.promotionRules);
      if (result && result.status) this.promotionRules = { ...this.promotionRules, ...result };
    } finally {
      this.savingRules = false;
    }
  }


}
